import logo from './logo.svg';
import './App.css';
import React from 'react';
import AppRouter from './Routes/AppRouter';

function App() {
  return (
    <React.StrictMode>
      <AppRouter />
    </React.StrictMode>
  );
}

export default App;
 